const PROTOCOL_DENYLIST = ['javascript', 'vbscript', 'frames', 'data', 'ftp', 'sftp'];
function matchesProtocolOnDenylist(url) {
  return !!PROTOCOL_DENYLIST.find(protocol => {
    let protocolRegex = new RegExp(`^${protocol}:`);
    if (protocolRegex.test(url)) {
      return true;
    }
    return false;
  });
}
export function cleanUrl(url) {
  if (url) {
    url = url.trim();
    let emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i;
    let isEmail = emailRegex.test(url);
    let hasMailTo = /^mailto:/.test(url);
    let hasProtocol = url.indexOf(':') !== -1;
    let isRelative = url.indexOf('/') === 0;
    let isAttribute = url.indexOf('{{') === 0;
    if (url && !isAttribute && !hasProtocol && !hasMailTo && !isEmail && !isRelative) {
      url = `https://${url}`;
    }
    if (isEmail && !hasMailTo) {
      url = `mailto:${url}`;
    }
    if (matchesProtocolOnDenylist(url)) {
      url = '';
    }
  }
  return url;
}